import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useQuery } from "@tanstack/react-query";
import { fetchCurrentTerms } from "@/server/services/termsService";
import { QUERY_KEYS } from "@/config/queryKeys";

export default function TermsPage() {
  const { t } = useTranslation();

  const {
    data: terms,
    isLoading,
    isError,
  } = useQuery({
    queryKey: QUERY_KEYS.termsCurrent,
    queryFn: fetchCurrentTerms,
    staleTime: Infinity,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return (
    <div className="h-screen overflow-y-auto bg-background">
      <div className="mx-auto max-w-3xl px-6 py-12">
        <img
          src="/orion-logo.svg"
          alt="ORION"
          className="mx-auto mb-8 size-20 dark:invert"
        />

        {isLoading && (
          <p className="py-20 text-center text-muted-foreground">
            {t("terms.loading")}
          </p>
        )}

        {isError && (
          <div className="rounded-lg border border-destructive/30 bg-destructive/10 p-6 text-center text-sm text-destructive">
            {t("terms.error")}
          </div>
        )}

        {terms && (
          <>
            <div className="mb-10 text-center">
              <h1 className="text-2xl font-bold text-foreground">
                {t("terms.title")}
              </h1>
              <p className="mt-2 text-sm text-muted-foreground">
                {t("terms.effectiveDate", {
                  date: new Date(terms.effective_date).toLocaleDateString(),
                })}
              </p>
              <p className="mt-1 text-xs text-muted-2">
                {t("terms.version", { version: terms.version })}
              </p>
            </div>

            <div className="prose prose-sm max-w-none dark:prose-invert">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {terms.content}
              </ReactMarkdown>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
